import React, { useState, useEffect, useRef } from "react";
import playIcon from "./../../../resources/images/utils/play_icon.svg";
import stopIcon from "./../../../resources/images/utils/stop_icon.svg";
import { AudioBlock } from "./styled";
import { Text } from "../../../styled";
import { whiteColor } from "../../../constants/colors";
import { createEventObjectFunction } from "../../../utils/helper";
import { onboardingFillEvent } from "../../../firebaseAnalytics/events";
import { analytics } from "../../../firebaseAnalytics";
import { onboardingFillEventAmplitude } from "../../../amplitude/events";

const AudioPlayer = (props) => {
  const {
    src,
    previewImage,
    title,
    name,
    key,
    setAudioPlayed,
    audioPlayed,
    style,
    currentPlayerIndex,
    setCurrentPlayerIndex,
    index,
    audioEventFillName,
    fillName,
    landingId,
  } = props;

  const [audioElement] = useState(new Audio(src));
  const [isPlay, setPlay] = useState(false);

  useEffect(() => {
    audioElement.addEventListener("ended", onEnded);
    return () => {
      audioElement.pause();
      setPlay(false);
      audioElement.removeEventListener("ended", onEnded);
    };
  }, []);

  useEffect(() => {
    if (currentPlayerIndex !== null && currentPlayerIndex !== index) {
      audioElement.pause();
      setPlay(false);
    }
  }, [currentPlayerIndex]);

  useEffect(() => {
    if (isPlay === true) {
      audioElement.play();
      setCurrentPlayerIndex(index);
      if (audioPlayed === false) {
        const eventObj = createEventObjectFunction(fillName, null, landingId);
        eventObj[audioEventFillName] = true;
        // Событие №4 fill
        onboardingFillEvent(analytics, eventObj);
        onboardingFillEventAmplitude(eventObj);
      }
      setAudioPlayed(true);
    }
  }, [isPlay]);

  const onEnded = () => {
    audioElement.pause();
    setPlay(false);
  };

  const handleControlClick = () => {
    if (isPlay) {
      audioElement.pause();
      setPlay(false);
    } else {
      setPlay(true);
    }
  };

  return (
    <AudioBlock key={key} style={style}>
      <AudioBlock.Control>
        <AudioBlock.Preview
          previewImage={previewImage}
          onClick={handleControlClick}
        >
          <AudioBlock.Control.Button>
            <img src={isPlay ? stopIcon : playIcon} alt="control" />
          </AudioBlock.Control.Button>
        </AudioBlock.Preview>
      </AudioBlock.Control>
      <AudioBlock.Info>
        <Text.Eight style={{ marginBottom: 2 }}>{title}</Text.Eight>
        <Text.Second style={{ color: whiteColor }}>{name}</Text.Second>
      </AudioBlock.Info>
    </AudioBlock>
  );
};

export default AudioPlayer;
